module.exports = lib_hoist_non_react_statics;